import styled from 'styled-components';
import device from '#app/interface/devices';

// Боковая колонка для детальной страницы (300px)
export const DetailSideColumn = styled.div`
  flex: 0 0 300px;
  min-width: 0;

  @media ${device.tablet} {
    flex: 1 1 100%;
    width: 100%;
  }
`;

// ===== СПЕЦИФИЧЕСКИЕ СТИЛИ =====

// Список робоэдвайзеров
export const RobosList = styled.div`
  margin-bottom: 24px;
`;

export const RobosListTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #202020;
  margin-bottom: 20px;
`;

// Секция с метриками (кликабельная)
export const MetricsSection = styled.div`
  margin-bottom: 40px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

// Обертка для пагинации
export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  padding: 20px 0;
  border-top: 1px solid #e5e7eb;
`;

export const ActionsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
`;

/** Обёртка кнопки «Все операции» под списком транзакций. */
export const AllOperationsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
